import Vue from 'vue'
import Router from 'vue-router'
import JobDetail from '@/view/JobDetail.vue'
import JobChance from '@/view/JobChance.vue'
import NewsDetail from '@/view/NewsDetail.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '关于我们'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '关于我们丨企业简介'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '关于我们丨发展历程'
              },
            },
            {
              path: '/software/honor',
              name: 'software',
              component: resolve => require(['@/view/Software_honor'], resolve),
              meta: {
                title: '关于我们丨企业荣誉及资质'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '公司业务'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/news-detail/:id/:category',
          name: 'newsdetail',
          component: NewsDetail,
          meta: {
            title: '新闻详情'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '政府政务服务'
          }
        },
        {
          path: '/serviceidc',
          name: 'serviceidc',
          component: resolve => require(['@/view/ServiceIDC'],resolve),
          meta: {
            title: 'IDC服务'
          }
        },
        {
          path: '/servicedata',
          name: 'servicedata',
          component: resolve => require(['@/view/ServiceDate'],resolve),
          meta: {
            title: '自建数据中心'
          }
        },
        {
          path: '/job-detail',
          name: 'JobDetail',
          component: JobDetail
        },

        {
          path: '/job-chance',
          name: 'JobChance',
          component: JobChance
        },
      ]
    }
  ]
})







// WEBPACK FOOTER //
// ./src/router/index.js